(function() { module.exports = window["Bernie_l10nBundle_fi_FI"]; }());